// source: proto/entity/anomaly.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var proto_common_amount_pb = require('../../proto/common/amount_pb.js');
goog.object.extend(proto, proto_common_amount_pb);
var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_datetime_pb = require('../../proto/common/datetime_pb.js');
goog.object.extend(proto, proto_common_datetime_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var proto_entity_site_pb = require('../../proto/entity/site_pb.js');
goog.object.extend(proto, proto_entity_site_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.entity.Anomaly', null, global);
goog.exportSymbol('proto.entity.Anomaly.DetailsCase', null, global);
goog.exportSymbol('proto.entity.AnomalySummary', null, global);
goog.exportSymbol('proto.entity.AnomalyV1', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.DeepDiveItem', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.DeepDiveItem.Type', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.DeepDiveItem.Type.Option', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.DimensionDefinition', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.DimensionValue', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.MetricAmount', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.MetricDefinition', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.ScriptSource', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.ScriptSource.Option', null, global);
goog.exportSymbol('proto.entity.AnomalyV1.TopLevelItem', null, global);
goog.exportSymbol('proto.entity.ImpactPeriod', null, global);
goog.exportSymbol('proto.entity.ImpactPeriod.Option', null, global);
goog.exportSymbol('proto.entity.ImpactType', null, global);
goog.exportSymbol('proto.entity.ImpactType.Option', null, global);
goog.exportSymbol('proto.entity.NewAnomaly', null, global);
goog.exportSymbol('proto.entity.NewAnomaly.DetailsCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.NewAnomaly = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.NewAnomaly.oneofGroups_);
};
goog.inherits(proto.entity.NewAnomaly, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.NewAnomaly.displayName = 'proto.entity.NewAnomaly';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.Anomaly = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.Anomaly.oneofGroups_);
};
goog.inherits(proto.entity.Anomaly, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.Anomaly.displayName = 'proto.entity.Anomaly';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalySummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AnomalySummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalySummary.displayName = 'proto.entity.AnomalySummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ImpactType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ImpactType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ImpactType.displayName = 'proto.entity.ImpactType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ImpactPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ImpactPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ImpactPeriod.displayName = 'proto.entity.ImpactPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.AnomalyV1.repeatedFields_, null);
};
goog.inherits(proto.entity.AnomalyV1, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.displayName = 'proto.entity.AnomalyV1';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.ScriptSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AnomalyV1.ScriptSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.ScriptSource.displayName = 'proto.entity.AnomalyV1.ScriptSource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.DimensionDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AnomalyV1.DimensionDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.DimensionDefinition.displayName = 'proto.entity.AnomalyV1.DimensionDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.MetricDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AnomalyV1.MetricDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.MetricDefinition.displayName = 'proto.entity.AnomalyV1.MetricDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.DimensionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AnomalyV1.DimensionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.DimensionValue.displayName = 'proto.entity.AnomalyV1.DimensionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.MetricAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AnomalyV1.MetricAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.MetricAmount.displayName = 'proto.entity.AnomalyV1.MetricAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.TopLevelItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.AnomalyV1.TopLevelItem.repeatedFields_, null);
};
goog.inherits(proto.entity.AnomalyV1.TopLevelItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.TopLevelItem.displayName = 'proto.entity.AnomalyV1.TopLevelItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.DeepDiveItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.AnomalyV1.DeepDiveItem.repeatedFields_, null);
};
goog.inherits(proto.entity.AnomalyV1.DeepDiveItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.DeepDiveItem.displayName = 'proto.entity.AnomalyV1.DeepDiveItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AnomalyV1.DeepDiveItem.Type = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AnomalyV1.DeepDiveItem.Type, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AnomalyV1.DeepDiveItem.Type.displayName = 'proto.entity.AnomalyV1.DeepDiveItem.Type';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.NewAnomaly.oneofGroups_ = [[3]];

/**
 * @enum {number}
 */
proto.entity.NewAnomaly.DetailsCase = {
  DETAILS_NOT_SET: 0,
  ANOMALY_V1: 3
};

/**
 * @return {proto.entity.NewAnomaly.DetailsCase}
 */
proto.entity.NewAnomaly.prototype.getDetailsCase = function() {
  return /** @type {proto.entity.NewAnomaly.DetailsCase} */(jspb.Message.computeOneofCase(this, proto.entity.NewAnomaly.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.NewAnomaly.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.NewAnomaly.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.NewAnomaly} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewAnomaly.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    datePoint: (f = msg.getDatePoint()) && proto_common_datetime_pb.DatePoint.toObject(includeInstance, f),
    summary: (f = msg.getSummary()) && proto.entity.AnomalySummary.toObject(includeInstance, f),
    anomalyV1: (f = msg.getAnomalyV1()) && proto.entity.AnomalyV1.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.NewAnomaly}
 */
proto.entity.NewAnomaly.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.NewAnomaly;
  return proto.entity.NewAnomaly.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.NewAnomaly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.NewAnomaly}
 */
proto.entity.NewAnomaly.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_datetime_pb.DatePoint;
      reader.readMessage(value,proto_common_datetime_pb.DatePoint.deserializeBinaryFromReader);
      msg.setDatePoint(value);
      break;
    case 4:
      var value = new proto.entity.AnomalySummary;
      reader.readMessage(value,proto.entity.AnomalySummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    case 3:
      var value = new proto.entity.AnomalyV1;
      reader.readMessage(value,proto.entity.AnomalyV1.deserializeBinaryFromReader);
      msg.setAnomalyV1(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.NewAnomaly.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.NewAnomaly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.NewAnomaly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewAnomaly.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getDatePoint();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_datetime_pb.DatePoint.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.AnomalySummary.serializeBinaryToWriter
    );
  }
  f = message.getAnomalyV1();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.AnomalyV1.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.NewAnomaly.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.NewAnomaly} returns this
*/
proto.entity.NewAnomaly.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewAnomaly} returns this
 */
proto.entity.NewAnomaly.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewAnomaly.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.DatePoint date_point = 2;
 * @return {?proto.common.DatePoint}
 */
proto.entity.NewAnomaly.prototype.getDatePoint = function() {
  return /** @type{?proto.common.DatePoint} */ (
    jspb.Message.getWrapperField(this, proto_common_datetime_pb.DatePoint, 2));
};


/**
 * @param {?proto.common.DatePoint|undefined} value
 * @return {!proto.entity.NewAnomaly} returns this
*/
proto.entity.NewAnomaly.prototype.setDatePoint = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewAnomaly} returns this
 */
proto.entity.NewAnomaly.prototype.clearDatePoint = function() {
  return this.setDatePoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewAnomaly.prototype.hasDatePoint = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AnomalySummary summary = 4;
 * @return {?proto.entity.AnomalySummary}
 */
proto.entity.NewAnomaly.prototype.getSummary = function() {
  return /** @type{?proto.entity.AnomalySummary} */ (
    jspb.Message.getWrapperField(this, proto.entity.AnomalySummary, 4));
};


/**
 * @param {?proto.entity.AnomalySummary|undefined} value
 * @return {!proto.entity.NewAnomaly} returns this
*/
proto.entity.NewAnomaly.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewAnomaly} returns this
 */
proto.entity.NewAnomaly.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewAnomaly.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AnomalyV1 anomaly_v1 = 3;
 * @return {?proto.entity.AnomalyV1}
 */
proto.entity.NewAnomaly.prototype.getAnomalyV1 = function() {
  return /** @type{?proto.entity.AnomalyV1} */ (
    jspb.Message.getWrapperField(this, proto.entity.AnomalyV1, 3));
};


/**
 * @param {?proto.entity.AnomalyV1|undefined} value
 * @return {!proto.entity.NewAnomaly} returns this
*/
proto.entity.NewAnomaly.prototype.setAnomalyV1 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.entity.NewAnomaly.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewAnomaly} returns this
 */
proto.entity.NewAnomaly.prototype.clearAnomalyV1 = function() {
  return this.setAnomalyV1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewAnomaly.prototype.hasAnomalyV1 = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.Anomaly.oneofGroups_ = [[5]];

/**
 * @enum {number}
 */
proto.entity.Anomaly.DetailsCase = {
  DETAILS_NOT_SET: 0,
  ANOMALY_V1: 5
};

/**
 * @return {proto.entity.Anomaly.DetailsCase}
 */
proto.entity.Anomaly.prototype.getDetailsCase = function() {
  return /** @type {proto.entity.Anomaly.DetailsCase} */(jspb.Message.computeOneofCase(this, proto.entity.Anomaly.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.Anomaly.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.Anomaly.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.Anomaly} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Anomaly.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: (f = msg.getSiteId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    anomalyId: (f = msg.getAnomalyId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    datePoint: (f = msg.getDatePoint()) && proto_common_datetime_pb.DatePoint.toObject(includeInstance, f),
    summary: (f = msg.getSummary()) && proto.entity.AnomalySummary.toObject(includeInstance, f),
    anomalyV1: (f = msg.getAnomalyV1()) && proto.entity.AnomalyV1.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.Anomaly}
 */
proto.entity.Anomaly.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.Anomaly;
  return proto.entity.Anomaly.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.Anomaly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.Anomaly}
 */
proto.entity.Anomaly.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setAnomalyId(value);
      break;
    case 3:
      var value = new proto_common_datetime_pb.DatePoint;
      reader.readMessage(value,proto_common_datetime_pb.DatePoint.deserializeBinaryFromReader);
      msg.setDatePoint(value);
      break;
    case 6:
      var value = new proto.entity.AnomalySummary;
      reader.readMessage(value,proto.entity.AnomalySummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    case 5:
      var value = new proto.entity.AnomalyV1;
      reader.readMessage(value,proto.entity.AnomalyV1.deserializeBinaryFromReader);
      msg.setAnomalyV1(value);
      break;
    case 4:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.Anomaly.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.Anomaly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.Anomaly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Anomaly.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getAnomalyId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getDatePoint();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_common_datetime_pb.DatePoint.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.entity.AnomalySummary.serializeBinaryToWriter
    );
  }
  f = message.getAnomalyV1();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.AnomalyV1.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID site_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Anomaly.prototype.getSiteId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Anomaly} returns this
*/
proto.entity.Anomaly.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Anomaly} returns this
 */
proto.entity.Anomaly.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Anomaly.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID anomaly_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Anomaly.prototype.getAnomalyId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Anomaly} returns this
*/
proto.entity.Anomaly.prototype.setAnomalyId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Anomaly} returns this
 */
proto.entity.Anomaly.prototype.clearAnomalyId = function() {
  return this.setAnomalyId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Anomaly.prototype.hasAnomalyId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.DatePoint date_point = 3;
 * @return {?proto.common.DatePoint}
 */
proto.entity.Anomaly.prototype.getDatePoint = function() {
  return /** @type{?proto.common.DatePoint} */ (
    jspb.Message.getWrapperField(this, proto_common_datetime_pb.DatePoint, 3));
};


/**
 * @param {?proto.common.DatePoint|undefined} value
 * @return {!proto.entity.Anomaly} returns this
*/
proto.entity.Anomaly.prototype.setDatePoint = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Anomaly} returns this
 */
proto.entity.Anomaly.prototype.clearDatePoint = function() {
  return this.setDatePoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Anomaly.prototype.hasDatePoint = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AnomalySummary summary = 6;
 * @return {?proto.entity.AnomalySummary}
 */
proto.entity.Anomaly.prototype.getSummary = function() {
  return /** @type{?proto.entity.AnomalySummary} */ (
    jspb.Message.getWrapperField(this, proto.entity.AnomalySummary, 6));
};


/**
 * @param {?proto.entity.AnomalySummary|undefined} value
 * @return {!proto.entity.Anomaly} returns this
*/
proto.entity.Anomaly.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Anomaly} returns this
 */
proto.entity.Anomaly.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Anomaly.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional AnomalyV1 anomaly_v1 = 5;
 * @return {?proto.entity.AnomalyV1}
 */
proto.entity.Anomaly.prototype.getAnomalyV1 = function() {
  return /** @type{?proto.entity.AnomalyV1} */ (
    jspb.Message.getWrapperField(this, proto.entity.AnomalyV1, 5));
};


/**
 * @param {?proto.entity.AnomalyV1|undefined} value
 * @return {!proto.entity.Anomaly} returns this
*/
proto.entity.Anomaly.prototype.setAnomalyV1 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.entity.Anomaly.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Anomaly} returns this
 */
proto.entity.Anomaly.prototype.clearAnomalyV1 = function() {
  return this.setAnomalyV1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Anomaly.prototype.hasAnomalyV1 = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.CRUDFields crud_fields = 4;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.Anomaly.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 4));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.Anomaly} returns this
*/
proto.entity.Anomaly.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Anomaly} returns this
 */
proto.entity.Anomaly.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Anomaly.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalySummary.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalySummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalySummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalySummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    impact: (f = msg.getImpact()) && google_protobuf_wrappers_pb.FloatValue.toObject(includeInstance, f),
    impactType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    impactPeriod: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalySummary}
 */
proto.entity.AnomalySummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalySummary;
  return proto.entity.AnomalySummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalySummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalySummary}
 */
proto.entity.AnomalySummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.FloatValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.FloatValue.deserializeBinaryFromReader);
      msg.setImpact(value);
      break;
    case 2:
      var value = /** @type {!proto.entity.ImpactType.Option} */ (reader.readEnum());
      msg.setImpactType(value);
      break;
    case 3:
      var value = /** @type {!proto.entity.ImpactPeriod.Option} */ (reader.readEnum());
      msg.setImpactPeriod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalySummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalySummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalySummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalySummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImpact();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.FloatValue.serializeBinaryToWriter
    );
  }
  f = message.getImpactType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getImpactPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.FloatValue impact = 1;
 * @return {?proto.google.protobuf.FloatValue}
 */
proto.entity.AnomalySummary.prototype.getImpact = function() {
  return /** @type{?proto.google.protobuf.FloatValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.FloatValue, 1));
};


/**
 * @param {?proto.google.protobuf.FloatValue|undefined} value
 * @return {!proto.entity.AnomalySummary} returns this
*/
proto.entity.AnomalySummary.prototype.setImpact = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AnomalySummary} returns this
 */
proto.entity.AnomalySummary.prototype.clearImpact = function() {
  return this.setImpact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AnomalySummary.prototype.hasImpact = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ImpactType.Option impact_type = 2;
 * @return {!proto.entity.ImpactType.Option}
 */
proto.entity.AnomalySummary.prototype.getImpactType = function() {
  return /** @type {!proto.entity.ImpactType.Option} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.entity.ImpactType.Option} value
 * @return {!proto.entity.AnomalySummary} returns this
 */
proto.entity.AnomalySummary.prototype.setImpactType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ImpactPeriod.Option impact_period = 3;
 * @return {!proto.entity.ImpactPeriod.Option}
 */
proto.entity.AnomalySummary.prototype.getImpactPeriod = function() {
  return /** @type {!proto.entity.ImpactPeriod.Option} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.entity.ImpactPeriod.Option} value
 * @return {!proto.entity.AnomalySummary} returns this
 */
proto.entity.AnomalySummary.prototype.setImpactPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ImpactType.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ImpactType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ImpactType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ImpactType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ImpactType}
 */
proto.entity.ImpactType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ImpactType;
  return proto.entity.ImpactType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ImpactType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ImpactType}
 */
proto.entity.ImpactType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ImpactType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ImpactType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ImpactType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ImpactType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.ImpactType.Option = {
  UNDEFINED: 0,
  REVENUE: 1,
  GOAL_COMPLETIONS: 2,
  GOAL_VALUE: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ImpactPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ImpactPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ImpactPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ImpactPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ImpactPeriod}
 */
proto.entity.ImpactPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ImpactPeriod;
  return proto.entity.ImpactPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ImpactPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ImpactPeriod}
 */
proto.entity.ImpactPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ImpactPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ImpactPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ImpactPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ImpactPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.ImpactPeriod.Option = {
  UNDEFINED: 0,
  TOTAL: 1,
  PER_WEEK: 2
};


/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.AnomalyV1.repeatedFields_ = [8,9,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.toObject = function(includeInstance, msg) {
  var f, obj = {
    scriptSource: jspb.Message.getFieldWithDefault(msg, 1, 0),
    gaViewId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    currentDateRange: (f = msg.getCurrentDateRange()) && proto_common_datetime_pb.DateRange.toObject(includeInstance, f),
    previousDateRange: (f = msg.getPreviousDateRange()) && proto_common_datetime_pb.DateRange.toObject(includeInstance, f),
    sortMetricAlias: jspb.Message.getFieldWithDefault(msg, 12, ""),
    queryRangePeriod: jspb.Message.getFieldWithDefault(msg, 5, ""),
    emailSubject: jspb.Message.getFieldWithDefault(msg, 6, ""),
    title: jspb.Message.getFieldWithDefault(msg, 7, ""),
    dimensionDefinitionsList: jspb.Message.toObjectList(msg.getDimensionDefinitionsList(),
    proto.entity.AnomalyV1.DimensionDefinition.toObject, includeInstance),
    metricDefinitionsList: jspb.Message.toObjectList(msg.getMetricDefinitionsList(),
    proto.entity.AnomalyV1.MetricDefinition.toObject, includeInstance),
    topLevelItem: (f = msg.getTopLevelItem()) && proto.entity.AnomalyV1.TopLevelItem.toObject(includeInstance, f),
    deepDiveItemsList: jspb.Message.toObjectList(msg.getDeepDiveItemsList(),
    proto.entity.AnomalyV1.DeepDiveItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1}
 */
proto.entity.AnomalyV1.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1;
  return proto.entity.AnomalyV1.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1}
 */
proto.entity.AnomalyV1.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.entity.AnomalyV1.ScriptSource.Option} */ (reader.readEnum());
      msg.setScriptSource(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGaViewId(value);
      break;
    case 3:
      var value = new proto_common_datetime_pb.DateRange;
      reader.readMessage(value,proto_common_datetime_pb.DateRange.deserializeBinaryFromReader);
      msg.setCurrentDateRange(value);
      break;
    case 4:
      var value = new proto_common_datetime_pb.DateRange;
      reader.readMessage(value,proto_common_datetime_pb.DateRange.deserializeBinaryFromReader);
      msg.setPreviousDateRange(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortMetricAlias(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueryRangePeriod(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailSubject(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 8:
      var value = new proto.entity.AnomalyV1.DimensionDefinition;
      reader.readMessage(value,proto.entity.AnomalyV1.DimensionDefinition.deserializeBinaryFromReader);
      msg.addDimensionDefinitions(value);
      break;
    case 9:
      var value = new proto.entity.AnomalyV1.MetricDefinition;
      reader.readMessage(value,proto.entity.AnomalyV1.MetricDefinition.deserializeBinaryFromReader);
      msg.addMetricDefinitions(value);
      break;
    case 10:
      var value = new proto.entity.AnomalyV1.TopLevelItem;
      reader.readMessage(value,proto.entity.AnomalyV1.TopLevelItem.deserializeBinaryFromReader);
      msg.setTopLevelItem(value);
      break;
    case 11:
      var value = new proto.entity.AnomalyV1.DeepDiveItem;
      reader.readMessage(value,proto.entity.AnomalyV1.DeepDiveItem.deserializeBinaryFromReader);
      msg.addDeepDiveItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScriptSource();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGaViewId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCurrentDateRange();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_common_datetime_pb.DateRange.serializeBinaryToWriter
    );
  }
  f = message.getPreviousDateRange();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_common_datetime_pb.DateRange.serializeBinaryToWriter
    );
  }
  f = message.getSortMetricAlias();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getQueryRangePeriod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmailSubject();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDimensionDefinitionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.entity.AnomalyV1.DimensionDefinition.serializeBinaryToWriter
    );
  }
  f = message.getMetricDefinitionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.entity.AnomalyV1.MetricDefinition.serializeBinaryToWriter
    );
  }
  f = message.getTopLevelItem();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.entity.AnomalyV1.TopLevelItem.serializeBinaryToWriter
    );
  }
  f = message.getDeepDiveItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.entity.AnomalyV1.DeepDiveItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.ScriptSource.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.ScriptSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.ScriptSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.ScriptSource.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.ScriptSource}
 */
proto.entity.AnomalyV1.ScriptSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.ScriptSource;
  return proto.entity.AnomalyV1.ScriptSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.ScriptSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.ScriptSource}
 */
proto.entity.AnomalyV1.ScriptSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.ScriptSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.ScriptSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.ScriptSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.ScriptSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.AnomalyV1.ScriptSource.Option = {
  UNDEFINED: 0,
  CHANNEL_AFFILIATE: 1,
  CHANNEL_EMAIL: 2,
  CHANNEL_PAID_SEARCH: 3,
  CHANNEL_REFERRAL: 4,
  MOBILE: 5,
  BROWSER: 6,
  PRODUCT: 7,
  PRODUCT_CATEGORY: 8,
  PRODUCT_CATEGORY_PRODUCTS: 9,
  PRODUCT_CATEGORY_SOURCES: 10,
  MONGO_ATLAS_ENDPOINT_REGISTRATIONS: 11,
  MONGO_ENTERPRISE_DOWNLOADS: 12,
  MONGO_COMMUNITY_DOWNLOADS: 13,
  TRAVELOCITY_AIR_CHANNELS: 14,
  PAID_SEARCH_ROAS: 15,
  PAID_SEARCH_REVENUE: 16,
  ANOMALY_GENERATOR: 17
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.DimensionDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.DimensionDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.DimensionDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DimensionDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    alias: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sourceName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.DimensionDefinition}
 */
proto.entity.AnomalyV1.DimensionDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.DimensionDefinition;
  return proto.entity.AnomalyV1.DimensionDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.DimensionDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.DimensionDefinition}
 */
proto.entity.AnomalyV1.DimensionDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.DimensionDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.DimensionDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.DimensionDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DimensionDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string alias = 1;
 * @return {string}
 */
proto.entity.AnomalyV1.DimensionDefinition.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.DimensionDefinition} returns this
 */
proto.entity.AnomalyV1.DimensionDefinition.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string source_name = 2;
 * @return {string}
 */
proto.entity.AnomalyV1.DimensionDefinition.prototype.getSourceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.DimensionDefinition} returns this
 */
proto.entity.AnomalyV1.DimensionDefinition.prototype.setSourceName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.MetricDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.MetricDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.MetricDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    alias: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sourceName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    columnName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    unitName: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.MetricDefinition}
 */
proto.entity.AnomalyV1.MetricDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.MetricDefinition;
  return proto.entity.AnomalyV1.MetricDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.MetricDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.MetricDefinition}
 */
proto.entity.AnomalyV1.MetricDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.MetricDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.MetricDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.MetricDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColumnName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnitName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string alias = 1;
 * @return {string}
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.MetricDefinition} returns this
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string source_name = 2;
 * @return {string}
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.getSourceName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.MetricDefinition} returns this
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.setSourceName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string column_name = 3;
 * @return {string}
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.getColumnName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.MetricDefinition} returns this
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.setColumnName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string unit_name = 4;
 * @return {string}
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.getUnitName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.MetricDefinition} returns this
 */
proto.entity.AnomalyV1.MetricDefinition.prototype.setUnitName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.DimensionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.DimensionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.DimensionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DimensionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    alias: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.DimensionValue}
 */
proto.entity.AnomalyV1.DimensionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.DimensionValue;
  return proto.entity.AnomalyV1.DimensionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.DimensionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.DimensionValue}
 */
proto.entity.AnomalyV1.DimensionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.DimensionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.DimensionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.DimensionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DimensionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string alias = 1;
 * @return {string}
 */
proto.entity.AnomalyV1.DimensionValue.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.DimensionValue} returns this
 */
proto.entity.AnomalyV1.DimensionValue.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.entity.AnomalyV1.DimensionValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.DimensionValue} returns this
 */
proto.entity.AnomalyV1.DimensionValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.MetricAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.MetricAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.MetricAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.MetricAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
    alias: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: (f = msg.getAmount()) && proto_common_amount_pb.Amount.toObject(includeInstance, f),
    formattedValue: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.MetricAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.MetricAmount;
  return proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.MetricAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlias(value);
      break;
    case 2:
      var value = new proto_common_amount_pb.Amount;
      reader.readMessage(value,proto_common_amount_pb.Amount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormattedValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.MetricAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.MetricAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlias();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_amount_pb.Amount.serializeBinaryToWriter
    );
  }
  f = message.getFormattedValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string alias = 1;
 * @return {string}
 */
proto.entity.AnomalyV1.MetricAmount.prototype.getAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.MetricAmount} returns this
 */
proto.entity.AnomalyV1.MetricAmount.prototype.setAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.Amount amount = 2;
 * @return {?proto.common.Amount}
 */
proto.entity.AnomalyV1.MetricAmount.prototype.getAmount = function() {
  return /** @type{?proto.common.Amount} */ (
    jspb.Message.getWrapperField(this, proto_common_amount_pb.Amount, 2));
};


/**
 * @param {?proto.common.Amount|undefined} value
 * @return {!proto.entity.AnomalyV1.MetricAmount} returns this
*/
proto.entity.AnomalyV1.MetricAmount.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AnomalyV1.MetricAmount} returns this
 */
proto.entity.AnomalyV1.MetricAmount.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AnomalyV1.MetricAmount.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string formatted_value = 3;
 * @return {string}
 */
proto.entity.AnomalyV1.MetricAmount.prototype.getFormattedValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.MetricAmount} returns this
 */
proto.entity.AnomalyV1.MetricAmount.prototype.setFormattedValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.AnomalyV1.TopLevelItem.repeatedFields_ = [2,4,5,6,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.TopLevelItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.TopLevelItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.TopLevelItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dimensionsList: jspb.Message.toObjectList(msg.getDimensionsList(),
    proto.entity.AnomalyV1.DimensionValue.toObject, includeInstance),
    primaryMetricAlias: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tableMetricAliasesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    currentAmountsList: jspb.Message.toObjectList(msg.getCurrentAmountsList(),
    proto.entity.AnomalyV1.MetricAmount.toObject, includeInstance),
    previousAmountsList: jspb.Message.toObjectList(msg.getPreviousAmountsList(),
    proto.entity.AnomalyV1.MetricAmount.toObject, includeInstance),
    changeAmountsList: jspb.Message.toObjectList(msg.getChangeAmountsList(),
    proto.entity.AnomalyV1.MetricAmount.toObject, includeInstance),
    gaLink: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.TopLevelItem}
 */
proto.entity.AnomalyV1.TopLevelItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.TopLevelItem;
  return proto.entity.AnomalyV1.TopLevelItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.TopLevelItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.TopLevelItem}
 */
proto.entity.AnomalyV1.TopLevelItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 2:
      var value = new proto.entity.AnomalyV1.DimensionValue;
      reader.readMessage(value,proto.entity.AnomalyV1.DimensionValue.deserializeBinaryFromReader);
      msg.addDimensions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryMetricAlias(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addTableMetricAliases(value);
      break;
    case 5:
      var value = new proto.entity.AnomalyV1.MetricAmount;
      reader.readMessage(value,proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader);
      msg.addCurrentAmounts(value);
      break;
    case 6:
      var value = new proto.entity.AnomalyV1.MetricAmount;
      reader.readMessage(value,proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader);
      msg.addPreviousAmounts(value);
      break;
    case 8:
      var value = new proto.entity.AnomalyV1.MetricAmount;
      reader.readMessage(value,proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader);
      msg.addChangeAmounts(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setGaLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.TopLevelItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.TopLevelItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.TopLevelItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDimensionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.entity.AnomalyV1.DimensionValue.serializeBinaryToWriter
    );
  }
  f = message.getPrimaryMetricAlias();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTableMetricAliasesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getCurrentAmountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter
    );
  }
  f = message.getPreviousAmountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter
    );
  }
  f = message.getChangeAmountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter
    );
  }
  f = message.getGaLink();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string summary = 1;
 * @return {string}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated DimensionValue dimensions = 2;
 * @return {!Array<!proto.entity.AnomalyV1.DimensionValue>}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getDimensionsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.DimensionValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.DimensionValue, 2));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.DimensionValue>} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
*/
proto.entity.AnomalyV1.TopLevelItem.prototype.setDimensionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.AnomalyV1.DimensionValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.DimensionValue}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.addDimensions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.AnomalyV1.DimensionValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.clearDimensionsList = function() {
  return this.setDimensionsList([]);
};


/**
 * optional string primary_metric_alias = 3;
 * @return {string}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getPrimaryMetricAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.setPrimaryMetricAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string table_metric_aliases = 4;
 * @return {!Array<string>}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getTableMetricAliasesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.setTableMetricAliasesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.addTableMetricAliases = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.clearTableMetricAliasesList = function() {
  return this.setTableMetricAliasesList([]);
};


/**
 * repeated MetricAmount current_amounts = 5;
 * @return {!Array<!proto.entity.AnomalyV1.MetricAmount>}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getCurrentAmountsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.MetricAmount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.MetricAmount, 5));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.MetricAmount>} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
*/
proto.entity.AnomalyV1.TopLevelItem.prototype.setCurrentAmountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.entity.AnomalyV1.MetricAmount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.addCurrentAmounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.entity.AnomalyV1.MetricAmount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.clearCurrentAmountsList = function() {
  return this.setCurrentAmountsList([]);
};


/**
 * repeated MetricAmount previous_amounts = 6;
 * @return {!Array<!proto.entity.AnomalyV1.MetricAmount>}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getPreviousAmountsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.MetricAmount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.MetricAmount, 6));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.MetricAmount>} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
*/
proto.entity.AnomalyV1.TopLevelItem.prototype.setPreviousAmountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.entity.AnomalyV1.MetricAmount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.addPreviousAmounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.entity.AnomalyV1.MetricAmount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.clearPreviousAmountsList = function() {
  return this.setPreviousAmountsList([]);
};


/**
 * repeated MetricAmount change_amounts = 8;
 * @return {!Array<!proto.entity.AnomalyV1.MetricAmount>}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getChangeAmountsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.MetricAmount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.MetricAmount, 8));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.MetricAmount>} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
*/
proto.entity.AnomalyV1.TopLevelItem.prototype.setChangeAmountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.entity.AnomalyV1.MetricAmount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.addChangeAmounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.entity.AnomalyV1.MetricAmount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.clearChangeAmountsList = function() {
  return this.setChangeAmountsList([]);
};


/**
 * optional string ga_link = 7;
 * @return {string}
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.getGaLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.TopLevelItem} returns this
 */
proto.entity.AnomalyV1.TopLevelItem.prototype.setGaLink = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.AnomalyV1.DeepDiveItem.repeatedFields_ = [2,4,5,6,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.DeepDiveItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.DeepDiveItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DeepDiveItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dimensionsList: jspb.Message.toObjectList(msg.getDimensionsList(),
    proto.entity.AnomalyV1.DimensionValue.toObject, includeInstance),
    primaryMetricAlias: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tableMetricAliasesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    currentAmountsList: jspb.Message.toObjectList(msg.getCurrentAmountsList(),
    proto.entity.AnomalyV1.MetricAmount.toObject, includeInstance),
    previousAmountsList: jspb.Message.toObjectList(msg.getPreviousAmountsList(),
    proto.entity.AnomalyV1.MetricAmount.toObject, includeInstance),
    changeAmountsList: jspb.Message.toObjectList(msg.getChangeAmountsList(),
    proto.entity.AnomalyV1.MetricAmount.toObject, includeInstance),
    isProblem: (f = msg.getIsProblem()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem}
 */
proto.entity.AnomalyV1.DeepDiveItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.DeepDiveItem;
  return proto.entity.AnomalyV1.DeepDiveItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.DeepDiveItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem}
 */
proto.entity.AnomalyV1.DeepDiveItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 2:
      var value = new proto.entity.AnomalyV1.DimensionValue;
      reader.readMessage(value,proto.entity.AnomalyV1.DimensionValue.deserializeBinaryFromReader);
      msg.addDimensions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrimaryMetricAlias(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addTableMetricAliases(value);
      break;
    case 5:
      var value = new proto.entity.AnomalyV1.MetricAmount;
      reader.readMessage(value,proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader);
      msg.addCurrentAmounts(value);
      break;
    case 6:
      var value = new proto.entity.AnomalyV1.MetricAmount;
      reader.readMessage(value,proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader);
      msg.addPreviousAmounts(value);
      break;
    case 9:
      var value = new proto.entity.AnomalyV1.MetricAmount;
      reader.readMessage(value,proto.entity.AnomalyV1.MetricAmount.deserializeBinaryFromReader);
      msg.addChangeAmounts(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsProblem(value);
      break;
    case 8:
      var value = /** @type {!proto.entity.AnomalyV1.DeepDiveItem.Type.Option} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.DeepDiveItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.DeepDiveItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DeepDiveItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDimensionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.entity.AnomalyV1.DimensionValue.serializeBinaryToWriter
    );
  }
  f = message.getPrimaryMetricAlias();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTableMetricAliasesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getCurrentAmountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter
    );
  }
  f = message.getPreviousAmountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter
    );
  }
  f = message.getChangeAmountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.entity.AnomalyV1.MetricAmount.serializeBinaryToWriter
    );
  }
  f = message.getIsProblem();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AnomalyV1.DeepDiveItem.Type.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AnomalyV1.DeepDiveItem.Type.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AnomalyV1.DeepDiveItem.Type} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DeepDiveItem.Type.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem.Type}
 */
proto.entity.AnomalyV1.DeepDiveItem.Type.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AnomalyV1.DeepDiveItem.Type;
  return proto.entity.AnomalyV1.DeepDiveItem.Type.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AnomalyV1.DeepDiveItem.Type} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem.Type}
 */
proto.entity.AnomalyV1.DeepDiveItem.Type.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AnomalyV1.DeepDiveItem.Type.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AnomalyV1.DeepDiveItem.Type.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AnomalyV1.DeepDiveItem.Type} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AnomalyV1.DeepDiveItem.Type.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.AnomalyV1.DeepDiveItem.Type.Option = {
  UNDEFINED: 0,
  CHILD: 1
};

/**
 * optional string summary = 1;
 * @return {string}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated DimensionValue dimensions = 2;
 * @return {!Array<!proto.entity.AnomalyV1.DimensionValue>}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getDimensionsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.DimensionValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.DimensionValue, 2));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.DimensionValue>} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
*/
proto.entity.AnomalyV1.DeepDiveItem.prototype.setDimensionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.AnomalyV1.DimensionValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.DimensionValue}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.addDimensions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.AnomalyV1.DimensionValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.clearDimensionsList = function() {
  return this.setDimensionsList([]);
};


/**
 * optional string primary_metric_alias = 3;
 * @return {string}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getPrimaryMetricAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.setPrimaryMetricAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string table_metric_aliases = 4;
 * @return {!Array<string>}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getTableMetricAliasesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.setTableMetricAliasesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.addTableMetricAliases = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.clearTableMetricAliasesList = function() {
  return this.setTableMetricAliasesList([]);
};


/**
 * repeated MetricAmount current_amounts = 5;
 * @return {!Array<!proto.entity.AnomalyV1.MetricAmount>}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getCurrentAmountsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.MetricAmount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.MetricAmount, 5));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.MetricAmount>} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
*/
proto.entity.AnomalyV1.DeepDiveItem.prototype.setCurrentAmountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.entity.AnomalyV1.MetricAmount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.addCurrentAmounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.entity.AnomalyV1.MetricAmount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.clearCurrentAmountsList = function() {
  return this.setCurrentAmountsList([]);
};


/**
 * repeated MetricAmount previous_amounts = 6;
 * @return {!Array<!proto.entity.AnomalyV1.MetricAmount>}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getPreviousAmountsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.MetricAmount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.MetricAmount, 6));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.MetricAmount>} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
*/
proto.entity.AnomalyV1.DeepDiveItem.prototype.setPreviousAmountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.entity.AnomalyV1.MetricAmount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.addPreviousAmounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.entity.AnomalyV1.MetricAmount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.clearPreviousAmountsList = function() {
  return this.setPreviousAmountsList([]);
};


/**
 * repeated MetricAmount change_amounts = 9;
 * @return {!Array<!proto.entity.AnomalyV1.MetricAmount>}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getChangeAmountsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.MetricAmount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.MetricAmount, 9));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.MetricAmount>} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
*/
proto.entity.AnomalyV1.DeepDiveItem.prototype.setChangeAmountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.entity.AnomalyV1.MetricAmount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.MetricAmount}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.addChangeAmounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.entity.AnomalyV1.MetricAmount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.clearChangeAmountsList = function() {
  return this.setChangeAmountsList([]);
};


/**
 * optional google.protobuf.BoolValue is_problem = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getIsProblem = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
*/
proto.entity.AnomalyV1.DeepDiveItem.prototype.setIsProblem = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.clearIsProblem = function() {
  return this.setIsProblem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.hasIsProblem = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Type.Option type = 8;
 * @return {!proto.entity.AnomalyV1.DeepDiveItem.Type.Option}
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.getType = function() {
  return /** @type {!proto.entity.AnomalyV1.DeepDiveItem.Type.Option} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.entity.AnomalyV1.DeepDiveItem.Type.Option} value
 * @return {!proto.entity.AnomalyV1.DeepDiveItem} returns this
 */
proto.entity.AnomalyV1.DeepDiveItem.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional ScriptSource.Option script_source = 1;
 * @return {!proto.entity.AnomalyV1.ScriptSource.Option}
 */
proto.entity.AnomalyV1.prototype.getScriptSource = function() {
  return /** @type {!proto.entity.AnomalyV1.ScriptSource.Option} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.entity.AnomalyV1.ScriptSource.Option} value
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.setScriptSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string ga_view_id = 2;
 * @return {string}
 */
proto.entity.AnomalyV1.prototype.getGaViewId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.setGaViewId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.DateRange current_date_range = 3;
 * @return {?proto.common.DateRange}
 */
proto.entity.AnomalyV1.prototype.getCurrentDateRange = function() {
  return /** @type{?proto.common.DateRange} */ (
    jspb.Message.getWrapperField(this, proto_common_datetime_pb.DateRange, 3));
};


/**
 * @param {?proto.common.DateRange|undefined} value
 * @return {!proto.entity.AnomalyV1} returns this
*/
proto.entity.AnomalyV1.prototype.setCurrentDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.clearCurrentDateRange = function() {
  return this.setCurrentDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AnomalyV1.prototype.hasCurrentDateRange = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.DateRange previous_date_range = 4;
 * @return {?proto.common.DateRange}
 */
proto.entity.AnomalyV1.prototype.getPreviousDateRange = function() {
  return /** @type{?proto.common.DateRange} */ (
    jspb.Message.getWrapperField(this, proto_common_datetime_pb.DateRange, 4));
};


/**
 * @param {?proto.common.DateRange|undefined} value
 * @return {!proto.entity.AnomalyV1} returns this
*/
proto.entity.AnomalyV1.prototype.setPreviousDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.clearPreviousDateRange = function() {
  return this.setPreviousDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AnomalyV1.prototype.hasPreviousDateRange = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string sort_metric_alias = 12;
 * @return {string}
 */
proto.entity.AnomalyV1.prototype.getSortMetricAlias = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.setSortMetricAlias = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string query_range_period = 5;
 * @return {string}
 */
proto.entity.AnomalyV1.prototype.getQueryRangePeriod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.setQueryRangePeriod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string email_subject = 6;
 * @return {string}
 */
proto.entity.AnomalyV1.prototype.getEmailSubject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.setEmailSubject = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string title = 7;
 * @return {string}
 */
proto.entity.AnomalyV1.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated DimensionDefinition dimension_definitions = 8;
 * @return {!Array<!proto.entity.AnomalyV1.DimensionDefinition>}
 */
proto.entity.AnomalyV1.prototype.getDimensionDefinitionsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.DimensionDefinition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.DimensionDefinition, 8));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.DimensionDefinition>} value
 * @return {!proto.entity.AnomalyV1} returns this
*/
proto.entity.AnomalyV1.prototype.setDimensionDefinitionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.entity.AnomalyV1.DimensionDefinition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.DimensionDefinition}
 */
proto.entity.AnomalyV1.prototype.addDimensionDefinitions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.entity.AnomalyV1.DimensionDefinition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.clearDimensionDefinitionsList = function() {
  return this.setDimensionDefinitionsList([]);
};


/**
 * repeated MetricDefinition metric_definitions = 9;
 * @return {!Array<!proto.entity.AnomalyV1.MetricDefinition>}
 */
proto.entity.AnomalyV1.prototype.getMetricDefinitionsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.MetricDefinition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.MetricDefinition, 9));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.MetricDefinition>} value
 * @return {!proto.entity.AnomalyV1} returns this
*/
proto.entity.AnomalyV1.prototype.setMetricDefinitionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.entity.AnomalyV1.MetricDefinition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.MetricDefinition}
 */
proto.entity.AnomalyV1.prototype.addMetricDefinitions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.entity.AnomalyV1.MetricDefinition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.clearMetricDefinitionsList = function() {
  return this.setMetricDefinitionsList([]);
};


/**
 * optional TopLevelItem top_level_item = 10;
 * @return {?proto.entity.AnomalyV1.TopLevelItem}
 */
proto.entity.AnomalyV1.prototype.getTopLevelItem = function() {
  return /** @type{?proto.entity.AnomalyV1.TopLevelItem} */ (
    jspb.Message.getWrapperField(this, proto.entity.AnomalyV1.TopLevelItem, 10));
};


/**
 * @param {?proto.entity.AnomalyV1.TopLevelItem|undefined} value
 * @return {!proto.entity.AnomalyV1} returns this
*/
proto.entity.AnomalyV1.prototype.setTopLevelItem = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.clearTopLevelItem = function() {
  return this.setTopLevelItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AnomalyV1.prototype.hasTopLevelItem = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * repeated DeepDiveItem deep_dive_items = 11;
 * @return {!Array<!proto.entity.AnomalyV1.DeepDiveItem>}
 */
proto.entity.AnomalyV1.prototype.getDeepDiveItemsList = function() {
  return /** @type{!Array<!proto.entity.AnomalyV1.DeepDiveItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.AnomalyV1.DeepDiveItem, 11));
};


/**
 * @param {!Array<!proto.entity.AnomalyV1.DeepDiveItem>} value
 * @return {!proto.entity.AnomalyV1} returns this
*/
proto.entity.AnomalyV1.prototype.setDeepDiveItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.entity.AnomalyV1.DeepDiveItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AnomalyV1.DeepDiveItem}
 */
proto.entity.AnomalyV1.prototype.addDeepDiveItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.entity.AnomalyV1.DeepDiveItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.AnomalyV1} returns this
 */
proto.entity.AnomalyV1.prototype.clearDeepDiveItemsList = function() {
  return this.setDeepDiveItemsList([]);
};


goog.object.extend(exports, proto.entity);
